import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


//component root
import { WrongUrlComponent } from "./wrong-url.component";
//routes
import { WrongUrlRoutes as routes } from "./wrong-url.routes";

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports:[
    WrongUrlComponent
  ],
  declarations: [WrongUrlComponent]
})
export class WrongUrlModule { }
